/* ═══════════════════════════════════════════════════════════════
   THS3 MOTION — companion script for ths3-transitions.css
   Created 2026-08-04.

   This does NOT hijack navigation. Every click still performs a
   normal full page load; the browser runs the view transition
   around it. All this script does is:

     1. tag the tapped product image so the browser knows to morph
        it into the PDP hero rather than cross-fade the page, and
     2. stamp a direction class so forward/back slide the right way.

   If this file fails to load, navigation and the baseline
   cross-fade both still work. Nothing here is load-bearing.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* The sectional-swipe fallback that used to live here was removed
     on 2026-08-06 along with the CSS it drove (see §4 of
     ths3-transitions.css). It wiped a whole section in as one
     curtain, which hid the finer motion inside the section instead
     of composing with it. Section entrance choreography now lives
     in assets/ths3-choreo.js, which works on every browser without
     needing a scroll-timeline fallback at all. This file is back to
     doing exactly one thing: page-to-page view transitions. */

  /* Bail on browsers without cross-document view transitions
     (Firefox today). They navigate normally — no errors, no cost. */
  var supported =
    typeof document !== 'undefined' &&
    'startViewTransition' in document &&
    CSS.supports('selector(::view-transition)');
  if (!supported) return;

  var HERO_CLASS = 'ths-vt-hero';

  function clearHero() {
    var prev = document.querySelector('.' + HERO_CLASS);
    if (prev) prev.classList.remove(HERO_CLASS);
  }

  /* ── 1. Shared-element morph ──────────────────────────────────
     view-transition-name must be unique in the document, so the
     name is applied to exactly one image at click time and removed
     as soon as we might come back to this page. */
  document.addEventListener(
    'click',
    function (ev) {
      var link = ev.target.closest('a[href]');
      if (!link) return;

      /* only same-origin product links, and never modified clicks
         (new tab / download / external) */
      if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button !== 0) return;
      if (link.target && link.target !== '_self') return;
      if (link.origin !== window.location.origin) return;
      if (link.pathname.indexOf('/products/') === -1) return;

      var card = link.closest('.card, .ct, [data-cart-line], article');
      if (!card) return;
      /* the visible image — .cur is the one the card carousel is showing */
      var img = card.querySelector('.cardshow__img.cur') || card.querySelector('img');
      if (!img) return;

      clearHero();
      img.classList.add(HERO_CLASS);
    },
    true
  );

  /* ── 2. Direction ─────────────────────────────────────────────
     pageswap fires on the OUTGOING document, pagereveal on the
     INCOMING one — the only supported way to communicate intent
     across two documents. sessionStorage carries the flag between
     them because the two pages share no JS context. */
  var KEY = 'ths-vt-dir';

  function depthOf(pathname) {
    if (pathname === '/' || pathname === '') return 0;
    if (pathname.indexOf('/products/') === 0 || pathname.indexOf('/products/') > -1) return 2;
    if (pathname.indexOf('/collections/') > -1) return 1;
    return 1;
  }

  window.addEventListener('pageswap', function (ev) {
    if (!ev.viewTransition) return;
    try {
      var nav = ev.activation && ev.activation.entry ? ev.activation.entry.url : null;
      var to = nav ? new URL(nav) : null;
      if (!to) return;
      var dir = depthOf(to.pathname) > depthOf(window.location.pathname) ? 'forward' : 'back';
      sessionStorage.setItem(KEY, dir);
      document.documentElement.classList.add('vt-' + dir);
    } catch (e) {
      /* storage can throw in private mode — the default cross-fade
         is a perfectly good outcome, so swallow and move on */
    }
  });

  window.addEventListener('pagereveal', function (ev) {
    if (!ev.viewTransition) return;
    var dir;
    try {
      dir = sessionStorage.getItem(KEY);
      sessionStorage.removeItem(KEY);
    } catch (e) {
      dir = null;
    }
    if (!dir) return;

    var root = document.documentElement;
    root.classList.add('vt-' + dir);
    /* strip the class once the transition is done, so it never
       leaks into the next navigation */
    ev.viewTransition.finished.finally(function () {
      root.classList.remove('vt-forward', 'vt-back');
      clearHero();
    });
  });

  /* Back/forward cache restore: drop any stale hero tag so the next
     forward navigation starts from a clean document. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      clearHero();
      document.documentElement.classList.remove('vt-forward', 'vt-back');
    }
  });
})();
